<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="pay-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title">确认兑换该道具?</h5>
                    <div class="pay-view">
                        <div class="goods-detail">
                            <div class="goods-wrapper">
                                <div class="goods-pic" v-tips="item.giftId"><game-item :locked="true" :id="item.giftId" :num="item.sendNum"></game-item></div>
                            </div>  
                        </div>                        
                    </div>

                    <div class="item-name">{{ item.giftName }}</div>
                                   
                    <div class="calc-view">
                        <div class="amount calc-item">
                            <div class="calc-label"><div class="label-amount">兑换数量：</div></div>
                            <van-stepper v-model="value" :max="max" integer />
                        </div>
                        <div class="total calc-item">
                            <div class="calc-label"><div class="label-cost">总消耗：</div></div>
                            <span class="price">积分<b>*{{ value * item.amt }}</b></span>
                        </div>
                    </div>

                    <div class="u-ctrl">
                        <div class="u-btn cancel" @click="closeModal"></div>
                        <div class="u-btn ok" @click="apply"></div>                       
                    </div>
                    
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
.pay-modal{
    position: relative;
    width: 625px;
    height: 555px;
    padding-top: 30px;
    box-sizing: border-box;      
    background-image: url(~@/assets/images/modal/bg-modal-comfirm.png);
}

.title{
    width: 516px;
    height: 52px;
    margin: 0 auto 15px;
    font-weight: 400;
    font-size: 0;
    color: transparent;
    text-align: center;
    background-image: url(~@/assets/images/modal/title-trade.png);  
}

.pay-view{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 543px;
    height: 232px;
    margin: -15px auto 0;
    background-image: url(~@/assets/images/modal/bg-comfirm.png);
}

.pay-view p{
    padding: 0 20px;
    line-height: 1.8;
}

.pay-view b{
    /* color: #fe5a1e; */
}

.goods-detail{
    .goods-wrapper{
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 118px;
        height: 118px;
        margin: 0 auto;
        background-image: url(~@/assets/images/shop/bg-item.png);
    }

    .goods-pic{
        width: 69px;
        height: 69px;
    }
}

.item-name{
    margin-top: -15px;
    margin-bottom: 10px;
    color: #b0a282;
    text-align: center;
}

.calc-item{
    display: flex;
    align-items: center;
    padding-left: 55px;
    margin-bottom: 10px;
    color: #696560;
    // justify-content: center;

    .price{
        b{
            color: #d33d27;
        }
    }
}

.warn{
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%; 
    margin-top: 15px;
    font-size: 20px;
    color: #c2393f;
    text-align: center;
    vertical-align: text-top;
}

.i-warn{
    display: inline-block;
    width: 21px;
    height: 21px;
    margin: 0 5px;
    background-image: url(~@/assets/images/modal/icon-warn.png);
    vertical-align: sub;
}

.u-ctrl{
    position: absolute;
    width: 100%;
    left: 50%;
    bottom: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transform: translateX(-50%);
    box-sizing: border-box;
    padding: 0 110px;
}

.u-ctrl .u-btn.ok{
    width: 186px;
    height: 56px;
    background-image: url(~@/assets/images/modal/btn-submit.png);    
}

.u-ctrl .u-btn.cancel{
    width: 186px;
    height: 56px;
    background-image: url(~@/assets/images/modal/btn-cancel.png);    
}

</style>

<script>
export default {
    data () {
        return {
            visible : false,
            gid : '2',
            giftName : '----',
            cost : 599,
            num : 1,
            score : 0,
            text : '',
            item : {},
            value : 1,
            max: 999,
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },
    mounted(){
        this.max = this.item.max == -1 ? 999 : this.item.max - this.item.orderNum;
    },
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },
        render_ex_list (){
            this.$get(ajax_url_map.ex_buy_list,{
                success : (data) => {
                    this.$store.commit("$_setExList", data.data);
                }
            })
        },          
        apply(){

            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.zid){
                this.$toast('请绑定大区');
                this.closeModal();

                return this.$bind_modal();
            }

            //if(this.level == 0)return this.$error_modal({text : '任务未完成'});

            //if(this.level < 4)return;

            this.$post(ajax_url_map.ex_score,{
                success : (data) => {
                    this.destroyElement();
                    this.$msg_modal('兑换成功');

                    //todo
                    this.render_ex_list();
                },
                error : (data) => {
                    this.destroyElement();
                    this.$msg_modal(data.message);
                }
            },{
                id : this.item.id,
                num : this.value,
                gid : this.item.groupId,
            })
        },        
    },    
}
</script>